// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Space,
  Table,
  TableColumnProps,
  Select
} from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';

const FormItem = Form.Item;
const Option = Select.Option;

interface UmsResource {
  id?: number;
  name: string;
  url: string;
  description?: string;
  categoryId?: number;
  createTime?: string;
}

interface ResourceCategory {
  id: number;
  name: string;
  sort?: number;
}

function ResourceManagement() {
  const navigate = useNavigate();
  const [form] = Form.useForm<UmsResource>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsResource[]>([]);
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState<ResourceCategory[]>([]);
  const formRef = useRef<any>({});

  // 获取资源分类列表
  const getCategoryList = () => {
    get('/resourceCategory/listAll')
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          setCategoryList(data || []);
        }
      })
      .catch(() => {
        Message.error('获取资源分类列表失败!');
      });
  };

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(10);
    }

    const searchValues = formSearch.getFieldsValue();
    const params: any = {
      pageNum: reset ? 1 : pageNum,
      pageSize: reset ? 10 : pageSize
    };

    if (searchValues.nameKeyword) {
      params.nameKeyword = searchValues.nameKeyword;
    }
    if (searchValues.urlKeyword) {
      params.urlKeyword = searchValues.urlKeyword;
    }
    if (searchValues.categoryId && searchValues.categoryId !== 'all') {
      params.categoryId = searchValues.categoryId;
    }

    get('/resource/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total: totalCount } = data || {};
          setTotal(totalCount || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '编号',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '资源名称',
      dataIndex: 'name',
      width: 200
    },
    {
      title: '资源路径',
      dataIndex: 'url',
      width: 250
    },
    {
      title: '描述',
      dataIndex: 'description',
      width: 200,
      render: (text) => text || '-'
    },
    {
      title: '添加时间',
      dataIndex: 'createTime',
      width: 180,
      render: (text) => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 150,
      render: (_, record: UmsResource) => (
        <Space>
          <Button 
            type="text" 
            onClick={() => edit(record)} 
            loading={loading}
          >
            编辑
          </Button>
          <Popconfirm 
            focusLock 
            title="提示" 
            content="是否要删除该资源?" 
            onOk={() => del(record)}
          >
            <Button 
              type="text" 
              status="danger" 
              loading={loading}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(10);
    getList(true);
  };

  // 新增资源
  const add = () => {
    formRef.current = {};
    form.resetFields();
    getCategoryList();
    setVisible(true);
  };

  // 删除资源
  const del = (record: UmsResource) => {
    if (!record.id) {
      Message.error('资源ID不存在！');
      return;
    }
    setLoading(true);

    post(`/resource/delete/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑资源
  const edit = (record: UmsResource) => {
    formRef.current = record;
    form.setFieldsValue(record);
    getCategoryList();
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values
      };

      if (formRef.current.id) {
        // 更新资源
        post(`/resource/update/${formRef.current.id}`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('编辑成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // 创建资源
        post(`/resource/create`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('新增成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 跳转到资源分类管理
  const handleGoToCategory = () => {
    navigate('/resource-category');
  };

  useEffect(() => {
    getList();
    getCategoryList();
  }, [pageNum, pageSize]);

  return (
    <div className="resource-management table-flex">
      <div className="filter-section">
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="名称:" field="nameKeyword">
            <Input style={{ width: 200 }} placeholder="资源名称" allowClear />
          </FormItem>
          <FormItem label="路径:" field="urlKeyword">
            <Input style={{ width: 200 }} placeholder="资源路径" allowClear />
          </FormItem>
          <FormItem label="分类:" field="categoryId">
            <Select style={{ width: 150 }} placeholder="资源分类" allowClear>
              <Option value="all">全部</Option>
              {categoryList.map(category => (
                <Option key={category.id} value={category.id}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <Button type="primary" onClick={add} loading={loading}>
            添加
          </Button>
          <Button style={{ marginLeft: 20 }} type="outline" onClick={handleGoToCategory} loading={loading}>
            资源分类
          </Button>
        </Form>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={dataList}
        className="table-scroll"
        pagination={{
          sizeCanChange: true,
          pageSize,
          total,
          showTotal: true,
          current: pageNum,
          onChange: (num, size) => {
            setPageNum(num);
            if (size && size !== pageSize) {
              setPageSize(size);
            }
          }
        }}
        scroll={{ y: '100%', x: '100%' }}
        loading={loading}
      />

      {/* 新增/编辑资源弹框 */}
      <Modal
        title={formRef.current.id ? '编辑资源' : '添加资源'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <FormItem 
            label="资源名称:" 
            field="name" 
            rules={[{ required: true, message: '请输入资源名称' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem 
            label="资源路径:" 
            field="url" 
            rules={[{ required: true, message: '请输入资源路径' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="资源分类:" field="categoryId">
            <Select 
              placeholder="请选择资源分类" 
              allowClear
              showSearch
              filterOption={(inputValue, option) => 
                option?.children?.toString().toLowerCase().includes(inputValue.toLowerCase())
              }
            >
              {categoryList.map(category => (
                <Option key={category.id} value={category.id}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="描述:" field="description">
            <Input.TextArea placeholder="请输入..." rows={3} />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default ResourceManagement;

